import Vue from "vue";
import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";
import Dictionary from "../data/dictionary.json";
import Data from "../data/data.json";
import Config from "../data/config.json";

Vue.use(Vuex);

/**
 * Uncomment vuex-persists for local testing, to keep your results
 * in local storage so you can refresh the results page without having
 * to go through the entire application
 */

//import VuexPersistence from 'vuex-persist'

// const vuexLocal = new VuexPersistence({
// 	key: 'youngvoice',
// 	storage: window.localStorage
// })

const store = new Vuex.Store({
  //plugins: [vuexLocal.plugin],

  state: {
    shareModalVisible: false,
    dictionary: Dictionary,
    data: Data,
    config: Config,
    selectedThemes: [],
    statementQue: [],
    statementHistory: [],
    currentStatementIndex: 0,
    totalStatements: null,
    results: [],
    videoMutedPreference: null,
  },

  getters: {
    getField,
    minimumThemesSelected: (state) => state.selectedThemes.length > 3,
    disabledNext: (state) => state.statementQue[0]?.position === undefined,
    disabledPrev: (state) => (state.currentStatementIndex === 0 ? true : false),
    noMoreStatements: (state) => state.statementQue.length === 0,
    getPartyById: (state) => (partyId) =>
      state.data.parties.find(({ id }) => id === parseInt(partyId)),
    getResultsByPartyId: (state) => (id) =>
      state.results.find(({ partyId }) => partyId === parseInt(id)),
    getAffinityById: (state) => (partyId) =>
      state.results.find((result) => result.partyId === parseInt(partyId)).affinity.length,
    getStatementIdsByTheme: (state) => (theme) =>
      state.data.statements
        .filter((statement) => theme === statement.theme)
        .flatMap((statement) => statement.id),
  },

  mutations: {
    updateField,

    toggleShareModal(state) {
      state.shareModalVisible = !state.shareModalVisible;
    },

    resetApp(state) {
      state.shareModalVisible = false;
      state.selectedThemes = [];
      state.statementQue = [];
      state.statementHistory = [];
      state.currentStatementIndex = 0;

      state.data.statements.forEach((statement) => delete statement.position);
    },

    toggleTheme(state, { name }) {
      const index = state.selectedThemes.indexOf(name);

      if (index === -1) {
        state.selectedThemes.push(name);
      } else {
        state.selectedThemes.splice(index, 1);
      }
    },

    updateStatementList(state) {
      // filter out statements by selected themes
      // shuffle final array
      const filterdStatements = state.data.statements
        .filter((statement) => {
          return state.selectedThemes.some((theme) => theme === statement.theme);
        })
        .sort((a, b)=> a.index - b.index);

      state.statementQue = filterdStatements;
      state.totalStatements = filterdStatements.length;
    },

    addStatementKey(state) {
      // the plugin needs the key to be a string in order to work correctly.
      state.statementQue.forEach((statement) => (statement.key = statement.id.toString()));
    },

    updateHistory(state, item) {
      state.statementHistory.push(item);
    },

    setCurrentStatementIndex(state, index) {
      state.currentStatementIndex = index;
    },

    matchResultsAffinity(state) {
      const matched = state.data.positions.filter((position) => {
        return state.statementHistory.some((statement) => {
          return position.statementId === statement.id && position.position === statement.position;
        });
      });

      state.results = matched;
    },

    groupResultsByParty(state) {
      const grouped = [];

      state.data.parties.forEach((party) => {
        const statements = state.results.filter((result) => result.partyId === party.id);

        grouped.push({
          partyId: party.id,
          affinity: statements,
        });
      });

      state.results = grouped;
    },

    sortResultsByAffinity(state) {
      state.results.sort((a, b) => b.affinity.length - a.affinity.length);
    },

    setVideoMutedPreference(state, prefrence) {
      console.log(prefrence);
      state.videoMutedPreference = prefrence;
    },
  },

  actions: {
    onThemeUpdate({ commit }, theme) {
      commit("toggleTheme", theme);
      commit("updateStatementList");
      commit("addStatementKey");
    },

    onSubmitStatement({ commit, state, getters, dispatch }, statement) {
      statement.item.position = this._vm.$convertType({ type: statement.type });

      commit("updateHistory", statement.item);
      commit("setCurrentStatementIndex", state.currentStatementIndex + 1);

      if (getters.noMoreStatements) {
        dispatch("caclulateResults");
      }
    },

    caclulateResults({ commit }) {
      commit("matchResultsAffinity");
      commit("groupResultsByParty");
      commit("sortResultsByAffinity");
    },
  },

  modules: {},
});

export default store;
